import { SuitabilityGrade } from '../types'

export const GRADE_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
  A: { label: 'A – Highly usable', color: '#27500A', bg: '#EAF3DE' },
  B: { label: 'B – Usable', color: '#633806', bg: '#FAEEDA' },
  C: { label: 'C – Moderate', color: '#0C447C', bg: '#E6F1FB' },
  D: { label: 'D – Limited', color: '#712B13', bg: '#FAECE7' },
  E: { label: 'E – Not recommended', color: '#791F1F', bg: '#FCEBEB' },
}

export const isValidSuitabilityGrade = (grade: string | undefined): grade is SuitabilityGrade => {
  return grade !== undefined && ['A', 'B', 'C', 'D', 'E'].includes(grade)
}
